export const getApplicant = state => state.applicant;
